module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-BoldItalic_1_99890158.bff11707.woff2";